import React from "react";
import BudgetVerwaltung from "../BudgetVerwaltung";

const BudgetVerwaltungWidget = () => (
  <div className="widget-content-scroll">
    <BudgetVerwaltung onDataChange={() => {}} readOnly={true} />
  </div>
);

export default BudgetVerwaltungWidget;
